import { render, staticRenderFns } from "./RecipeIngredientForm.vue?vue&type=template&id=66a2822e&"
import script from "./RecipeIngredientForm.vue?vue&type=script&lang=js&"
export * from "./RecipeIngredientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports